export default [{
	titulo: 'Grupo de Acesso',
	icone: 'menu-icon fa fa-caret-right',
	url: '/admin/grupo-de-acesso',
	visualizar: false,
	actions: [{
		value: false,
		name: 'Cadastrar'
	}, {
		value: false,
		name: 'Editar'
	}, {
		value: false,
		name: 'Apagar'
	}]
}]